<coin-market-loading-bar></coin-market-loading-bar>
<coin-market-navbar></coin-market-navbar>
<div class="root">
    <router-outlet></router-outlet>
</div>
<coin-market-scroll-top></coin-market-scroll-top>
<coin-market-footer></coin-market-footer>
